import * as React from "react";
const SvgJourney = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      d="M2.667 0C1.192 0 0 1.148 0 2.567c0 1.925 2.667 4.766 2.667 4.766s2.666-2.841 2.666-4.766C5.333 1.147 4.141 0 2.667 0Zm-.242 4.907a9.008 9.008 0 0 1-.814-1.378c-.186-.407-.278-.741-.278-.962 0-.671.585-1.234 1.334-1.234.749 0 1.333.563 1.333 1.234 0 .22-.091.555-.278.962-.193.422-.472.89-.814 1.378-.079.112-.16.223-.241.334-.082-.11-.163-.222-.242-.334Zm10.908 3.76c-1.474 0-2.666 1.147-2.666 2.566 0 1.925 2.666 4.767 2.666 4.767S16 13.158 16 11.233c0-1.419-1.192-2.566-2.667-2.566Zm-.241 4.906a9.009 9.009 0 0 1-.815-1.377c-.186-.407-.277-.741-.277-.963 0-.67.584-1.233 1.333-1.233.75 0 1.334.562 1.334 1.233 0 .222-.092.556-.278.963-.193.421-.472.89-.814 1.377-.079.113-.16.224-.242.334a14.37 14.37 0 0 1-.241-.334ZM2 12h1.333v1.333H2V12Zm1.333-1.333V9.333H2v1.334h1.333ZM4.667 12H6v1.333H4.667V12Zm4 0H7.333v1.333h1.334V12Z"
    />
  </svg>
);
export default SvgJourney;
